import { Component, Input, OnInit } from '@angular/core';
import { Garage } from '@shared/models';
import { AmplitudeEventService, FeatureFlagService } from '@core/services';
import { ContractCreateOpened } from '@integrations/amplitude';

@Component({
  selector: 'app-garage-details',
  templateUrl: './garage-details.component.html',
  styleUrl: './garage-details.component.scss',
})
export class GarageDetailsComponent implements OnInit {
  @Input() garage?: Garage;
  @Input() allowContractCreation: boolean = true;

  showWiparkShortTermParking: boolean = this.featureFlagService.getFeatureFlag('translation_key') === 'wipark';

  //TODO: figure out if we gatekeep this behind a payment method on dashboard but not here or to make it consistent
  creatingContractEnabled!: boolean;

  constructor(
    private featureFlagService: FeatureFlagService,
    private amplitudeEventService: AmplitudeEventService,
  ) {}

  ngOnInit(): void {
    this.creatingContractEnabled =
      this.featureFlagService.getFeatureFlag('enable_contract_creation_products') && this.allowContractCreation;
  }

  get bookableContractTemplates() {
    return this.garage?.contract_templates?.filter((template) => template.bookable === 'public' && template.approval_required !== true) || [];
  }

  get contractRequestTemplates() {
    return this.garage?.contract_templates?.filter((template) => template.bookable === 'public' && template.approval_required === true) || [];
  }

  get informationContractTemplates() {
    return this.garage?.contract_templates?.filter((template) => template.bookable === 'information') || [];
  }

  get noContractsAvailable() {
    return this.bookableContractTemplates.length === 0 && this.informationContractTemplates.length === 0 && this.contractRequestTemplates.length === 0;
  }

  formatAddress(garage: Garage): string {
    return `${garage.street} ${garage.number}, ${garage.zip_code} ${garage.city}`;
  }

  sendAddContractEventToAmplitude(): void {
    if (!this.creatingContractEnabled) {
      return;
    }
    this.amplitudeEventService.trackEvent(
      new ContractCreateOpened({
        referredByPage: 'products',
        contractType: 'contract',
      }),
    );
  }

  sendAddContractRequestEventToAmplitude(): void {
    if (!this.creatingContractEnabled) {
      return;
    }
    this.amplitudeEventService.trackEvent(
      new ContractCreateOpened({
        referredByPage: 'products',
        contractType: 'request',
      }),
    );
  }
}
